import { StorageService } from '../../services/common/StorageService';

const STORAGE_KEY = 'impersonatedUserId';

const ImpersonationService = {
    getUserId,
    setUserId,
    clear,
};

function getUserId(): number | null {
    const stored = StorageService.getLocal<unknown>(STORAGE_KEY);
    return typeof stored === 'number' && Number.isFinite(stored)
        ? stored
        : null;
}

function setUserId(userId: number) {
    StorageService.setLocal(STORAGE_KEY, userId);
}

function clear() {
    StorageService.deleteLocal(STORAGE_KEY);
}

export default ImpersonationService;
